var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4208_5280",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4208_5280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.90193 9.99992L9.72589 9.18293L7.57738 7.03443V4.01727H6.42276V7.51921L8.90193 9.99992ZM7.00007 13.2184C6.20976 13.2184 5.46828 13.0696 4.77563 12.7719C4.08298 12.4742 3.4763 12.065 2.95559 11.5443C2.43488 11.0236 2.02568 10.4162 1.72801 9.72214C1.43033 9.02806 1.28149 8.28506 1.28149 7.49315C1.28149 6.70122 1.43033 5.95802 1.72801 5.26355C2.02568 4.56907 2.43488 3.9639 2.95559 3.44805C3.4763 2.9322 4.08369 2.52544 4.77776 2.22776C5.47184 1.93009 6.21484 1.78125 7.00675 1.78125C7.79867 1.78125 8.5419 1.93125 9.23644 2.23126C9.93098 2.53127 10.5351 2.93842 11.0489 3.45272C11.5627 3.96701 11.9694 4.57179 12.2691 5.26705C12.5688 5.9623 12.7186 6.70656 12.7186 7.49983C12.7186 8.29014 12.5698 9.03162 12.2721 9.72427C11.9745 10.4169 11.5677 11.0236 11.0518 11.5443C10.536 12.065 9.93019 12.4742 9.23444 12.7719C8.53869 13.0696 7.7939 13.2184 7.00007 13.2184ZM7.007 12.008C8.25419 12.008 9.3162 11.5678 10.193 10.6876C11.0698 9.80727 11.5082 8.74237 11.5082 7.49287C11.5082 6.24337 11.0698 5.18079 10.193 4.30514C9.31624 3.4295 8.25425 2.99168 7.00706 2.99168C5.75986 2.99168 4.69554 3.4295 3.81409 4.30514C2.93265 5.18079 2.49193 6.24337 2.49193 7.49287C2.49193 8.74237 2.93264 9.80727 3.81407 10.6876C4.69548 11.5678 5.75979 12.008 7.007 12.008Z",
    fill: "#8999B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.f8cc103fb769b9fcf402a267e5a3a3da.svg";
export { ForwardRef as ReactComponent };